module.exports = __webpack_public_path__ + "static/img/cadasto-nova-senha-success.a528d25a.svg";